import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { getRegPath } from "../../../constants";
import * as actions from "../../../store/actions/";
import { VALIDATE_SIGNUP } from "../../../store/actions/actionTypes";

import Row from "../../../components/uiElements/grid/Row";
import Button from "../../../components/formElements/button/Button";
import TextInput from "../../../components/formElements/input/TextInput";
import Checkbox from "../../../components/formElements/checkbox/Checkbox";
import SpinnerBorder from "../../../components/uiElements/loadingSpinner/SpinnerBorder";

const SignUp = ({
  signUpData,
  emailVerification,
  setSignUpData,
  form,
  validateData,
  history,
  apiUtil,
}) => {
  useEffect(() => {
    if (form && form.signUpValid) {
      emailVerification(() => {
        history.push(getRegPath("/verify-email"));
      });
      form.signUpValid = false;
    }
    // eslint-disable-next-line
  }, [form]);

  return (
    <div className="container" style={{ marginTop: "10%", maxWidth: 400 }}>
      <h2 className="auth-header mb-5">
        Account
        <br /> Sign Up
      </h2>
      <Row>
        <div
          className="col-md-12 text-left mb-5 mt-4"
          onKeyDown={event => {
            if (event.keyCode === 13 && signUpData.agreeTermAndConditions) {
              validateData(signUpData);
            }
          }}
        >
          <TextInput
            error={form.firstName}
            maxLength={15}
            type="text"
            label="First Name"
            value={signUpData.firstName}
            onChange={val => setSignUpData({ firstName: val })}
          />
          <TextInput
            error={form.lastName}
            maxLength={15}
            type="text"
            label="Last Name"
            value={signUpData.lastName}
            onChange={val => setSignUpData({ lastName: val })}
          />
          <TextInput
            error={form.email}
            type="text"
            label="Email Id"
            value={signUpData.email}
            onChange={val => setSignUpData({ email: val })}
          />
          <TextInput
            error={form.password}
            type="password"
            label="Password"
            value={signUpData.password}
            onChange={val => setSignUpData({ password: val })}
          />
          <Checkbox
            className="ml-n3"
            containerClassName="mt-n3"
            label={
              <span>
                I agree with the{" "}
                <a
                  href="https://urgidoctorprod3.s3.amazonaws.com/terms.html"
                  target="_blank"
                  className="decoration"
                >
                  Terms & Conditions
                </a>{" "}
                and{" "}
                <a
                  href="https://urgidoctorprod3.s3.amazonaws.com/privacy_policy.html"
                  target="_blank"
                  className="decoration"
                >
                  Privacy Policy
                </a>
              </span>
            }
            checked={signUpData.agreeTermAndConditions}
            onChange={checked =>
              setSignUpData({ agreeTermAndConditions: checked })
            }
          />
        </div>
      </Row>
      <div>
        <Button
          label={apiUtil.isLoading ? <SpinnerBorder /> : "Sign Up"}
          disabled={!signUpData.agreeTermAndConditions}
          className="mb-5"
          onClick={() => validateData(signUpData)}
        />
      </div>
      <p className="text-center">
        Already have an account?{" "}
        <Link className="link font-weight-bold" to={getRegPath("/signin")}>
          Sign In
        </Link>
      </p>
      <p className="text-center">
        <Link className="link font-weight-bold" to={getRegPath("/")}>
          Back to user selection
        </Link>
      </p>
    </div>
  );
};

const mapStoreToProps = ({ registration, validation, api }) => ({
  signUpData: registration,
  form: validation.data,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  setSignUpData: updatedData => dispatch(actions.setSignUpData(updatedData)),
  validateData: signUpData =>
    dispatch(actions.validateData(VALIDATE_SIGNUP, signUpData)),
  emailVerification: cb => dispatch(actions.emailVerification(cb)),
});
export default connect(mapStoreToProps, mapDispatchToProps)(SignUp);
